// extracted by mini-css-extract-plugin
export default {"selectWide":"index_selectWide__L2ySH","wrapper":"index_wrapper__rxpeV","label":"index_label__5pjIP","label-text":"index_label-text__JiQEP","value":"index_value__Gob55"};